import React from 'react';
import { IconCheck, IconXmark, IconExclamationTriangle } from '../ui-kit/icons';
import { Popover, OverlayTrigger } from '../ui-kit';
import ContractConstraintTable from './ContractConstraintTable';

const iconMapping = {
  satisfied: IconCheck,
  unsatisfied: IconXmark,
  on_limit: IconExclamationTriangle
};

const colorMapping = {
  satisfied: 'text-success',
  unsatisfied: 'text-danger',
  on_limit: 'text-warning'
};

// Exported indicator, used in ContractComplianceWidget
export const StatusIndicator = ({ status }) => {
  return statusIndicatorIcon(status);
};

// Needs to be a function, not a Component, because OverlayTrigger won't work
// otherwise. Reason unknown, don't care enough to investigate
const statusIndicatorIcon = status => {
  if (!status) return null;
  const Icon = iconMapping[status];
  const color = colorMapping[status];

  return <Icon size="lg" className={color} fixedWidth />;
};

const ContractConstraintIndicator = ({ contractStatistics, popoverPlacement = 'left' }) => {
  if (!contractStatistics || !contractStatistics.user_id) return null;
  const userId = contractStatistics.user_id;
  const constraintEvaluation = contractStatistics.constraint_evaluation;

  if (!contractStatistics.constraint_overall_status) return null;
  if (!constraintEvaluation) return null;

  const popover = (
    <Popover id={`contract-type-constraint-popover-${userId}`} className="d-flex flex-column flex-wrap popover">
      <Popover.Header className="d-flex flex-wrap">
        {I18n.t('activerecord.models.reporting/contracts/contract_type_constraint')}
      </Popover.Header>
      <Popover.Body className="d-flex flex-wrap">
        <ContractConstraintTable className="d-flex" constraintEvaluation={constraintEvaluation} />
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger placement={popoverPlacement} overlay={popover}>
      {statusIndicatorIcon(contractStatistics.constraint_overall_status)}
    </OverlayTrigger>
  );
};

export default ContractConstraintIndicator;
